import Header from './components/Header';
import Hero from './components/Hero';
import BookingEmbed from './components/BookingEmbed';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-sans">
      <Header />
      <main>
        <Hero />
        <BookingEmbed />
        <HowItWorks />
        <Services />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}